import { ActivateMemberResponse } from "../models/activate-member-response";
import { ApiResponse } from "../models/api-response";
import { ClubMember } from "../models/club-member";
import { IframeResponse } from "../models/iframe-url-response";
import { InterestedUser } from "../models/interested-user";
import { PluginConfig } from "../models/plugin-config";
import { RegistrationResponse } from "../models/registration-response";
import { getISO3LangCode } from "../utils/helpers";

export async function getFieldAvailability(
    field: string,
    value: string,
    config: PluginConfig | null,
    bookingDomain: string | undefined
): Promise<ApiResponse<boolean>> {
    field = field.replace("email", "mail");

    const url = `${bookingDomain}api/club/available-${field}?lang=${getISO3LangCode(config?.language)}&chainId=${config?.chainId}`;

    const response = await fetch(url,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                [field]: value
            }),
            credentials: 'include'
        }
    );
    if (!response.ok) throw new Error('Failed to get field availability');
    return response.json();
}
export async function registerClubMember(
    clubMember: ClubMember,
    config: PluginConfig | null,
    bookingDomain: string | undefined,
    salesClerk: string = "",
    hotelId: string = "",
    isUpdate: boolean = false
): Promise<ApiResponse<RegistrationResponse>> {
    let url = `${bookingDomain}api/club/${isUpdate ? 'update' : 'register'}-member?lang=${getISO3LangCode(config?.language)}&chainId=${config?.chainId}`;

    if (salesClerk) {
        url += `&salesClerk=${salesClerk}`;
    }
    if (hotelId) {
        url += `&hotelid=${hotelId}`;
    }
    let headers: any = {
        'Content-Type': 'application/json'
    };
    if (config?.termsSourceCode) {
        headers['x-terms-source'] = config.termsSourceCode;
    }
    const response = await fetch(url,
        {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ ...clubMember }),
            credentials: 'include'
        }
    );
    if (!response.ok) throw new Error('Failed to get field availability');
    return response.json();
}
export async function getIframeURL(
    config: PluginConfig | null,
    GuestID: number,
    clubMemberEmail: string,
    membershipAction: "join" | "renew",
    bookingDomain: string | undefined,
): Promise<IframeResponse> {
    const url: string = `${bookingDomain}PCI/GetIframeUrl` +
        `?chainId=${config?.chainId}` +
        `&lang=${getISO3LangCode(config?.language)}` +
        `&${membershipAction}=1` +
        `&paramx=${GuestID}` +
        `&tid=1` +
        `&email=${clubMemberEmail}`
let headers : any = {
        'Content-Type': 'application/json'
    };
    if (config?.termsSourceCode) {
        headers['x-terms-source'] = config.termsSourceCode;
    }
    
    const response = await fetch(url, {
        method: 'GET',
        headers: headers
        
    });
    if (!response.ok) throw new Error('Failed to get PCI Iframe');
    return response.json();
}
export async function activateMember(
    config: PluginConfig | null,
    guestId: number,
    transactionId: string,
    isRenew: boolean,
    salesClerk: any = null,
    hotelId: any = null,
    bookingDomain: string | undefined
): Promise<ApiResponse<ActivateMemberResponse>> {
    const url = `${bookingDomain}api/club/activate-member` +
        `?lang=${getISO3LangCode(config?.language)}` +
        `&chainId=${config?.chainId}` +
        `&guestId=${guestId}` +
        `&transactionID=${transactionId}` +
        `&isRenew=${isRenew}` +
        `${!!salesClerk ? `&salesClerk=${salesClerk}` : ""}` +
        `${!!hotelId ? `&hotelId=${hotelId}` : ""}`

    let headers: any = {
        'Content-Type': 'application/json'
    };
    if (config?.termsSourceCode) {
        headers['x-terms-source'] = config.termsSourceCode;
    }

    const response = await fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to get field availability');
    return response.json();
}
export async function getInterestedUser(
    config: PluginConfig | null,
    guestId: number,
    isRenew: boolean,
    bookingDomain: string | undefined
): Promise<ApiResponse<InterestedUser>> {
    const url = `${bookingDomain}api/club/interested-user` +
        `?lang=${getISO3LangCode(config?.language)}` +
        `&chainId=${config?.chainId}` +
        `&guestId=${guestId}` +
        `&isRenew=${isRenew}`

    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to get field availability');
    return response.json();
}